import React from "react";
import Education from '../../assets/Services/Simx/Industry_domains/Education.svg'
import Energy_and_Utilities from '../../assets/Services/Simx/Industry_domains/Finance.svg'
import Healthcare from '../../assets/Services/Simx/Industry_domains/Healthcare.svg'
import Hospitality from '../../assets/Services/Simx/Industry_domains/Hospitality.svg'
import IT from '../../assets/Services/Simx/Industry_domains/IT.svg'
import Manufacturing from '../../assets/Services/Simx/Industry_domains/Manufacturing.svg'
import Retail from '../../assets/Services/Simx/Industry_domains/Retail.svg'
import Finance from '../../assets/Services/Simx/Industry_domains/Finance.svg'

const FancyBlock = () => {
  const fancyBlockCotent = [
    {
      id: 1,
      icon:Healthcare,
      title: "Healthcare",
      text: `Simplify the process to create proposals.`,
      delayAnim: "0",
    },
    {
      id: 2,
      icon: Education,
      title: "Education",
      text: `Return money within 7 days only!`,
      delayAnim: "100",
    },
    {
      id: 3,
      icon: Manufacturing,
      title: "Manufacturing",
      text: `We ensure secure payment with PEV`,
      delayAnim: "200",
    },
    {
      id: 4,
      icon: IT,
      title: "IT",
      text: `We provide world best security system`,
      delayAnim: "300",
    },
    ,
    {
      id: 5,
      icon: Finance,
      title: "Finance",
      text: `We provide world best security system`,
      delayAnim: "300",
    }
    ,
    {
      id: 6,
      icon: Retail,
      title: "Retail",
      text: `We provide world best security system`,
      delayAnim: "300",
    }
    ,
    {
      id: 7,
      icon:Hospitality,
      title: "Hospitality",
      text: `We provide world best security system`,
      delayAnim: "300",
    }
    ,
    {
      id: 8,
      icon: Energy_and_Utilities,
      title: "Energy and Utilities",
      text: `We provide world best security system`,
      delayAnim: "300",
    }
  ];

  return (
    <>
      {fancyBlockCotent.map((item) => (
        <div
          className="col-lg-3 col-md-4 col-6"
     
          data-aos-delay={item.delayAnim}
          key={item.id}
        >
          <div className="block-style-thirtyNine mb-3 text-center">
            <div className="icon rounded-circle d-flex align-items-center justify-content-center m-auto">
              <img src={item.icon} alt="icon" className="p-2" />
            </div>
            <h3 className="h1-para mt-3 mb-2">{item.title}</h3>
            {/* <p className="ps-xl-3 pe-xl-3">{item.text}</p> */}
          </div>
          {/* <!-- /.block-style-thirtyNine --> */}
        </div>
      ))}
    </>
  );
};

export default FancyBlock;
